export function generateCourseCode(name) {
  const words = String(name || '')
    .trim()
    .split(/\s+/)
    .filter(Boolean);

  if (!words.length) return 'CRS101';

  const prefix = words
    .slice(0, 4)
    .map((word) => word.replace(/[^a-z0-9]/gi, '').charAt(0))
    .join('')
    .toUpperCase();

  return `${prefix || 'CRS'}101`;
}
